import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../../Common/Loader/loader";
//import { innergetAllZoneWiseReport } from "../../../Apis/satReportsApi";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";
import { GetZone } from "../../../../Apis/organizationApi";

import ExcelJS from "exceljs";

const ZoneAndVehicleWiseContainerReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const location = useLocation();
  const [dataWithTotal, setDataWithTotal] = useState(null);

  useEffect(() => {
    if (location.state) {
      setData(location.state); // Set data when it's available
    } else {
      //fetchData(); // Fetch data when component mounts if state is not available
    }
  }, [location.state]);
    useEffect(() => {
      const calculateContainerTotals = (data) => {
        const totals = {
          zoneName: "Total",
          tonnage: 0,
        };
  
        data.forEach((row) => {
          totals.tonnage +=  row.tonnage || 0;
        });
        return totals;
      };
      const totalZoneRow = calculateContainerTotals(location.state || []);
      const ContainerDataWithTotal = [...location.state, totalZoneRow];
      setDataWithTotal(ContainerDataWithTotal);
    }, [location.state]);

  const Columns = [
    {
      name: "Sl.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width:"100px"
    },
    {
      name: "Zone Name",
      selector: (row) => (
        <span>
          {row["zoneName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "TS Name",
      selector: (row) => (
        <span
        //  style={{ color: "blue" }}
        >{row["transferStationName"]}</span>
      ),
      sortable: true,
    },
    {
      name: "Container Name",
      selector: (row) => (
        <span
        >
          {row["containerName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle No.",
      selector: (row) => (
        <span>
          {row["vehicleNumber"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Capacity",
      selector: (row) => (
        <span>
          {row["vehicleModel"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Total QTY(MT)",
      selector: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["tonnage"].toFixed(2)}</span>
      ),
      sortable: true,
    },
  ];


  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = ` Container Trip Detailed Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Trips&Tonnage");
  
    // Define styles
   const boldFont = { bold: true };
  
  // Add the downloadDateTime to the correct row and columns, and ensure formatting
  worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
  worksheet.mergeCells(1, 2, 1, 4); // Merge cells for downloadDateTime from column 2 to 4
  worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
  worksheet.getCell(1, 2).font = boldFont; // Set font style
  worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content
  
  // Apply styles to the merged cells (B1, C1, D1)
  for (let col = 2; col <= 4; col++) {
    worksheet.getCell(1, col).font = boldFont; // Set styles individually
    worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
  }
  
  // Add "Zone Details" to the correct row and columns, and ensure formatting
  worksheet.addRow(["", "", "Container Trip Detailed Report", ""]); // Update array length to match new cell range
  worksheet.mergeCells(2, 2, 2, 4); // Merge cells for Zone Details from column 2 to 4
  worksheet.getCell(2, 2).value = " Container Trip Detailed Report"; // Ensure the value is set after merging
  worksheet.getCell(2, 2).font = boldFont; // Set font style
  worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content
  
  // Apply styles to the merged cells (B2, C2, D2)
  for (let col = 2; col <= 4; col++) {
    worksheet.getCell(2, col).font = boldFont; // Set styles individually
    worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
  }
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone Name",
      "TS Name",
      "Container Name",
      "Vehicle No.",
      "Vehicle Capacity",
      "Total QTY(MT)",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left",color:"#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 8) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });
  
    let totalTonnage = 0;
    // Add data rows
    data.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName?? "N/A",
          item.transferStationName?? "N/A",
          item.containerName?? "N/A",
          item.vehicleNumber?? "N/A",
          item.vehicleModel?? "N/A",
          item.tonnage?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 8) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
      totalTonnage += item.tonnage || 0;
    });
  
    // Add total row with bold font
    const totalRow = worksheet.addRow([
      "",
      "Total",
      "",
      "",
      "",
      "",
      totalTonnage.toFixed(2)
    ]);
    totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 1 && colNumber <= 8) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });
  
    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
    ];
  
    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ContainerTripDetailedReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header"></div>
            <div class="row" style={{ textAlign: "justify" }}>
            </div>
            <div className="card">
              <div className="card-body p-3">
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <button className="btn btn-secondary  me-2" style={{}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <button className="btn btn-excel"
                    onClick={downloadAsExcel}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>

                </div>

                <div className="top-header">
                  <span>
                    Container Trip Detailed Report
                  </span>
                </div>
                {data &&
                  <CustomDataTable
                    data={dataWithTotal}
                    columns={Columns}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default ZoneAndVehicleWiseContainerReport;
